<div class="validation-display-element validation-display-element-hint" [ngClass]="classes">
    <div>
        <div class="validation-display-icon fa" [ngClass]="{'fa-times': item?.active, 'fa-check': !item?.active}"></div>
        <div class="validation-display-error-text">{{item?.error?.hint || item.key}}</div>
    </div>
</div>
